import { CapabilitySet } from "@/types/capability.types";

/**
 * REST `capabilities` array → FE `CapabilitySet`. Tolerates `null`/`undefined`
 * (BE not yet shipping the field, deploy gap, resolver fail-closed) by mapping
 * to an empty set — capability checks then simply fail and the legacy
 * permission arm decides.
 */
export const mapToCapabilitySet = (input: string[] | null | undefined): CapabilitySet =>
  new Set(input ?? []);
